import { createWithEqualityFn } from "zustand/traditional";

type FlipState = {
  flips: Record<string, boolean>;
  get: (key: string, defaultValue?: boolean) => boolean;
  set: (key: string, value: boolean) => void;
  reset: () => void;
};

const useFlipStore = createWithEqualityFn<FlipState>((set, get) => ({
  flips: {},
  get: (key, defaultValue = false) => {
    const state = get();
    return key in state.flips ? state.flips[key] : defaultValue;
  },
  set: (key, value) =>
    set((state) => ({
      flips: {
        ...state.flips,
        [key]: value,
      },
    })),
  reset: () => set({ flips: {} }),
}));

export const flipStoreGet = useFlipStore.getState().get;
export const flipStoreSet = useFlipStore.getState().set;
export const flipStoreReset = useFlipStore.getState().reset;
